import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-players-character-list',
    templateUrl: './players-character-list.component.html',
    styleUrls: ['./players-character-list.component.scss'],
    standalone: false
})
export class PlayersCharacterListComponent implements OnInit {
  @Input() id: any
  @Input() playerListdata: any;

  constructor( private activemodel: NgbActiveModal,
) { }
  ngOnInit(): void {
  }



  closemodel() {
    this.activemodel.close();
  }

}
